import React, { FC } from "react";
import { useLocalAnalyticsState } from "../../../graphql/hooks";
import { GET_USER_ANALYTICS_QUERY_ANALYTIC } from "../../../graphql/queries";
import { useQuery } from "@apollo/client";
import {
    DailyAnalyticVariables,
    UserQueryAnalyticData
} from "../../../models/types";
import { formatDateRange } from "../../../common/AnalyticsHelpers";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

interface Props {
    reference: string;
    referenceId: number;
}

const UserQueryBadgesImplementation: FC<Props> = ({
    reference,
    referenceId
}) => {
    const { analyticsEnabled } = useLocalAnalyticsState();
    const savedDateRange = localStorage.getItem("user-query-date-range");
    const parsedDateRange = savedDateRange
        ? JSON.parse(savedDateRange)
        : undefined;

    const { data: { getUserQueryAnalytic } = {} } = useQuery<
        UserQueryAnalyticData,
        DailyAnalyticVariables
    >(GET_USER_ANALYTICS_QUERY_ANALYTIC, {
        variables: { referenceId: referenceId, reference: reference },
        fetchPolicy: "network-only",
        skip:
            !analyticsEnabled || !savedDateRange || parsedDateRange.length === 0
    });

    if (
        !getUserQueryAnalytic ||
        getUserQueryAnalytic.impressions <= 0 ||
        !savedDateRange ||
        parsedDateRange.length === 0
    ) {
        return null;
    }

    const formattedDateRange = parsedDateRange
        ? formatDateRange(parsedDateRange[0], parsedDateRange[1])
        : "N/A";

    const gameplay = getUserQueryAnalytic.gameplay || 0;
    const endScreen = getUserQueryAnalytic.endScreen || 0;
    const ctr = (
        ((gameplay + endScreen) / getUserQueryAnalytic.impressions) *
        100
    ).toFixed(1);

    return (
        <div className="d-flex small-font float-end px-2">
            <OverlayTrigger
                overlay={
                    <Tooltip id="user-impressions-tooltip">
                        {`Impressions - ${formattedDateRange}`}
                    </Tooltip>
                }
                delay={{
                    show: 100,
                    hide: 200
                }}
            >
                <div className="me-2">
                    {getUserQueryAnalytic.impressions.toLocaleString()}
                </div>
            </OverlayTrigger>
            <div className="text-secondary">|</div>
            <OverlayTrigger
                overlay={
                    <Tooltip id="user-ctr-tooltip">
                        {`CTR - ${formattedDateRange}`}
                    </Tooltip>
                }
                delay={{
                    show: 100,
                    hide: 200
                }}
            >
                <div style={{ whiteSpace: "nowrap" }} className="ms-2">
                    {ctr} %
                </div>
            </OverlayTrigger>
        </div>
    );
};

export const UserQueryBadges = React.memo(UserQueryBadgesImplementation);
